var CollectionView = require('views/base/collection-view');

var ResourceCollectionView = CollectionView.extend({
  noWrap: false,
  autoRender: true,
  template: require('./templates/resource-collection'),
  listSelector: '.resource-items',
  itemView: require('./resource-item-view'),
  animationDuration: 0,
  initItemView: function(model) {
    return new this.itemView({
      blockModel: this.model,
      autoRender: false,
      noWrap: true,
      model: model
    });
  },
  getTemplateData: Chaplin.View.prototype.getTemplateData
});

module.exports = ResourceCollectionView;